import React, { HTMLAttributes, PropsWithChildren } from 'react';
import c from 'classnames';
import SimpleTooltipText from '../SimpleTooltipText';
import s from './SimpleTooltipContent.scss';

interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'prefix'> {
  prefix?: React.ReactNode;
  postfix?: React.ReactNode;
}

const SimpleTooltipContent = React.forwardRef<
  HTMLElement,
  PropsWithChildren<Props>
>(({ prefix, postfix, children, className, ...rest }, ref) => (
  <div className={c(s['root'], className)} ref={ref as any} {...rest}>
    {prefix && <div className={s['prefix']}>{prefix}</div>}
    <SimpleTooltipText className={s['text']}>{children}</SimpleTooltipText>
    {postfix && <div className={s['postfix']}>{postfix}</div>}
  </div>
));
SimpleTooltipContent.displayName = 'SimpleTooltipContent';

export default SimpleTooltipContent;
